import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { ColumnChooserModel } from '../models/common/ColumnChooserModel';
import { ColumnFilterModel } from '../models/common/ColumnFilterModel';

/**
 * Genel Giderler > Yakıt Kayıtları (27.10.2026, #489 / #490). Yakıt ALIM fişi: satırlar (tür, miktar, birim, birim fiyat,
 * KDV), toplamlar sunucuda yeniden hesaplanır. Sefer yalnız referans; yakıt seferlere dağıtılmaz.
 */

export const YAKIT_SAYFASI = 'Genel Giderler > Yakıt Kayıtları';

export interface YakitListIstegi {
    searchTerm: string
    skip: number
    take: number
    currentPage: number
    columnChooser: ColumnChooserModel[] | undefined
    sortColumn?: string
    sortDirection?: string
    columnFilters: ColumnFilterModel[]
    ids?: string[]
}

export const ilkYakitListIstegi: YakitListIstegi = {
    searchTerm: '',
    skip: 0,
    take: 50,
    currentPage: 1,
    columnChooser: undefined,
    columnFilters: []
}

export interface YakitSatiri {
    yakitTuruId: string
    yakitTuru?: string
    birimId: string
    birim?: string
    miktar: number
    birimFiyat: number
    kdvOraniId: string
    kdvOrani: number
    net: number
    kdv: number
    brut: number
    hesapYonu: number
    not?: string
}

export interface YakitKaydi {
    yakitKaydiId: string
    belgeNo: string
    islemTarihiStr: string
    islemTarihiDeger: string
    islemSaati?: string
    vehicleId: string
    plaka?: string
    aracCinsi?: string
    driverId?: string
    surucu?: string
    tedarikciId?: string
    yakitFirmasi?: string
    kilometre?: number
    seferModulu?: number
    seferModuluAdi?: string
    seferId?: string
    seferNo?: string
    seferDurumu?: string
    yakitTurleri?: string
    toplamMiktar?: number
    birim?: string
    toplamNet: number
    toplamKdv: number
    toplamBrut: number
    currencyTypeId: string
    dovizCinsi?: string
    kur: number
    toplamNetTL: number
    toplamKdvTL: number
    toplamBrutTL: number
    aciklama?: string
    /** 1 Elle, 2 Excel, 3 Petrol Ofisi (#547). */
    kaynak?: number
    kaynakAdi: string
    mukerrerOnayi: boolean
    satirlar: YakitSatiri[]
    isSelected?: boolean
}

/** Dip toplamlar: filtrelenmiş bütün kayıtlar (sayfaya bağlı değil). */
export interface YakitToplamlari {
    toplamMiktar?: number
    birim?: string
    toplamNet?: number
    toplamKdv?: number
    toplamBrut?: number
    dovizCinsi?: string
    farkliDoviz: boolean
    toplamNetTL: number
    toplamKdvTL: number
    toplamBrutTL: number
}

export interface YakitSatirKaydet {
    yakitTuruId?: string
    birimId?: string
    miktar?: number
    birimFiyat?: number
    kdvOraniId?: string
    net?: number
    kdv?: number
    brut?: number
    hesapYonu: number
    not?: string
}

export interface YakitKaydet {
    id?: string
    belgeNo?: string
    islemTarihi?: string
    islemSaati?: string
    vehicleId?: string
    driverId?: string
    tedarikciId?: string
    kilometre?: number
    seferModulu?: number
    seferId?: string
    currencyTypeId?: string
    aciklama?: string
    mukerrerOnayi: boolean
    satirlar: YakitSatirKaydet[]
}

export interface YakitKaydetSonucu {
    kayit?: YakitKaydi
    uyarilar: string[]
    mukerrerOnayiGerekli: boolean
    mukerrerMesaji?: string
}

export interface YakitSecenek { value: string, label: string, ek?: string }

export interface YakitPlakaSecenegi extends YakitSecenek {
    varsayilanSurucuId?: string
    varsayilanSurucu?: string
}

export interface YakitSeferSecenegi {
    value: string
    label: string
    modul: number
    modulAdi: string
    vehicleId?: string
    plaka?: string
    driverId?: string
    tarihler?: string
    ayniArac: boolean
}

export interface YakitSecenekleri {
    yakitTurleri: YakitSecenek[]
    birimler: YakitSecenek[]
    /** ek = oran ("20"). */
    kdvOranlari: YakitSecenek[]
    dovizCinsleri: YakitSecenek[]
    varsayilanDovizId?: string
    varsayilanBirimId?: string
    varsayilanKdvOraniId?: string
    varsayilanYakitTuruId?: string
}

export interface YakitExcelSatiri {
    dosya?: string
    satirNo: number
    fisNo: number
    belgeNo?: string
    islemTarihi?: string
    plaka?: string
    surucu?: string
    yakitFirmasi?: string
    yakitTuru?: string
    miktar?: number
    birim?: string
    birimFiyat?: number
    kdvOrani?: number
    net?: number
    kdv?: number
    brut?: number
    dovizCinsi?: string
    seferNo?: string
    hatalar: string[]
    uyarilar: string[]
    /** Aynı fiş zaten kayıtlı; aktarılmaz (hata sayılmaz, #547). */
    tekrar?: boolean
}

export interface YakitExcelSonucu {
    satirSayisi: number
    fisSayisi: number
    /** Tekrarları saymaz (#547); Aktar'da bu satırlar Aktarım Hataları'na düşer. */
    hataliSatir: number
    uyariliSatir: number
    /** Zaten kayıtlı satırlar (aktarılmaz). */
    tekrarSatir?: number
    /** Aktar sonrası Aktarım Hataları ekranına düşen satır sayısı. */
    hataEkraninda?: number
    ornekSatirAtlandi: boolean
    toplamBrutTL: number
    satirlar: YakitExcelSatiri[]
    hata?: string
    ayniDosyaUyarisi?: string
    dosyalar: { ad: string, bicim: string, satirSayisi: number }[]
    aktarilan: number
}

/** Petrol Ofisi entegrasyon durumu (yakıt listesi açılışında; #547). */
export interface YakitEntegrasyonDurumu {
    petrolOfisiTanimli: boolean
    sonCalisma: string | null
    bekleyenHata: number
}

/** Aktarım hatası satırı (Petrol Ofisi ya da Excel'den gelip fişe dönüşemeyen satış; #547). */
export interface YakitAktarimHatasi {
    id: string
    kaynak: number
    kaynakAdi: string
    islemTarihiStr?: string
    islemZamani?: string
    islemSaati?: string
    plaka?: string
    uttsNo?: string
    yakitTuru?: string
    miktar?: number
    brut?: number
    aciklama?: string
    hata?: string
    durum: number
    durumAdi: string
    hariciIslemNo?: string
    yakitKaydiId?: string
    olusturmaStr?: string
    isSelected?: boolean
}

export interface YakitHataIslemSonucu {
    duzeltilen: number
    kalan: number
    hatalar: string[]
}

const cagir = async (yol: string, inputObj: any) => {
    try {
        console.log('SERVICE CALL - Yakit/' + yol, JSON.stringify(inputObj));

        const resp = await axios.post(Helpers.getEndpoint() + '/Yakit/' + yol, inputObj);

        return Helpers.dataParser(resp);
    } catch (error) {
        throw Helpers.parseErrorMessage(error);
    }
}

const dosyaGonder = async (yol: string, dosyalar: File[]) => {
    try {
        const form = new FormData();
        dosyalar.forEach(d => form.append('dosyalar', d));

        const resp = await axios.post(Helpers.getEndpoint() + '/Yakit/' + yol, form, { headers: { 'Content-Type': 'multipart/form-data' } });

        return Helpers.dataParser(resp);
    } catch (error) {
        throw Helpers.parseErrorMessage(error);
    }
}

export class YakitService {
    static getList(inputObj: YakitListIstegi) { return cagir('GetListPagingAndFilter', inputObj); }
    static exportList(inputObj: YakitListIstegi) { return cagir('ExportList', inputObj); }
    static getById(id: string) { return cagir('GetById', { id }); }
    static kaydet(inputObj: YakitKaydet) { return cagir('Kaydet', inputObj); }
    static sil(ids: string[]) { return cagir('Sil', { ids }); }
    static secenekler() { return cagir('Secenekler', {}); }
    static plakalar() { return cagir('Plakalar', {}); }
    static suruculer() { return cagir('Suruculer', {}); }
    static seferler(vehicleId?: string, arama?: string) { return cagir('Seferler', { vehicleId, arama }); }
    static ornekExcel() { return cagir('OrnekExcel', {}); }
    static excelOnizle(dosyalar: File[]) { return dosyaGonder('ExcelOnizle', dosyalar); }
    static excelAktar(dosyalar: File[]) { return dosyaGonder('ExcelAktar', dosyalar); }
    static mukerrerKontrol(id: string | undefined, belgeNo: string | undefined, tedarikciId: string | undefined) { return cagir('MukerrerKontrol', { id, belgeNo, tedarikciId }); }

    // Petrol Ofisi entegrasyonu ve aktarım hataları (#547)
    static entegrasyonDurumu() { return cagir('EntegrasyonDurumu', {}); }
    static petrolOfisiCek(baslangic?: string, bitis?: string) { return cagir('PetrolOfisiCek', { baslangic, bitis }); }
    static petrolOfisiTest() { return cagir('PetrolOfisiTest', {}); }
    static aktarimHatalari(inputObj: YakitListIstegi) { return cagir('AktarimHatalari', inputObj); }
    static aktarimHatalariExport(inputObj: YakitListIstegi) { return cagir('AktarimHatalariExport', inputObj); }
    static hataDuzelt(id: string, vehicleId: string, yakitTuruId?: string | null) { return cagir('HataDuzelt', { id, vehicleId, yakitTuruId }); }
    static hataYenidenIsle(ids: string[]) { return cagir('HataYenidenIsle', { ids }); }
    static hataYokSay(ids: string[]) { return cagir('HataYokSay', { ids }); }
}
